import { render } from "./FacilitySettings.vue?vue&type=template&id=a8835438&scoped=true"
import script from "./FacilitySettings.vue?vue&type=script&lang=js"
export * from "./FacilitySettings.vue?vue&type=script&lang=js"

import "./FacilitySettings.vue?vue&type=style&index=0&id=a8835438&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8835438"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon});
